var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "skeleton", class: { animate: _vm.animate } },
          [
            _vm.showAvatar
              ? _c("div", {
                  staticClass: "skeleton-avatar",
                  class: [_vm.avatarShape],
                  style: { width: _vm.avatarSize, height: _vm.avatarSize }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "skeleton-content" }, [
              _vm.showTitle
                ? _c("div", {
                    staticClass: "skeleton-title",
                    style: { width: _vm.titleWidth }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "skeleton-rows" },
                _vm._l(_vm.rowList, function(item, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "skeleton-row-item",
                    style: { width: item.width }
                  })
                }),
                0
              )
            ])
          ]
        )
      : _c("div", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2542c38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2542c38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base_package/Skeleton.vue
// module id = null
// module chunks = 